if (!customElements.get("inspiration-no-variant")) {
	customElements.define(
		"inspiration-no-variant",
		class InspirationNoVariant extends HTMLElement {
			constructor() {
				super();
				this.variantDropDown();
			}

			async renderProduct(productUrl, parent) {
				try {
					const response = await fetch(
						`${location.origin}${productUrl}?view=inspiration-no-variant`
					);
					const docs = await response.text();
					const html_ = new DOMParser().parseFromString(docs, "text/html");
					const productGridInfo = html_.querySelector(
						"[js-product-card-inner-wrapper]"
					);
					const variantPicker = html_.querySelector(
						"[js-inspiration-variant-picker]"
					);
					const productData = JSON.parse(
						html_.querySelector("[js-product-data-json]").innerHTML
					);
					const productDiscountData = JSON.parse(
						html_.querySelector("[js-product-discount-json]").innerHTML
					);

					if (productGridInfo && variantPicker) {
						parent.querySelector("[js-product-card-inner-wrapper]").innerHTML =
							productGridInfo.innerHTML;
						parent.querySelector("[js-inspiration-variant-picker]").innerHTML =
							variantPicker.innerHTML;
					}

					if (!productData.available) {
						parent.classList.add("sold-out");
						if (parent.classList.contains("selected")) {
							parent.querySelector("[js-product-card-inner-wrapper]").click();
						}
					} else {
						parent.classList.remove("sold-out");
					}
					const productPercent = Number(
						productDiscountData.productDiscountValue
					);
					if (productPercent) {
						parent.setAttribute(
							"data-product-price",
							productData.price - (productData.price * productPercent) / 100
						);
					} else {
						parent.setAttribute("data-product-price", productData.price);
					}
					parent
						.closest("accordion-content")
						.updateButtonInputs(parent, productData.variants[0].id);
					parent.closest("accordion-content").updatePrice();
				} catch (error) {
					console.error("Error fetching product details:", error);
				}
			}

			variantDropDown() {
				const customDropdown = this.querySelectorAll(
					"[js-no-variant-dropdown]"
				);
				const customDropdownValue = this.querySelectorAll(
					"[js-no-variant-dropdown] [js-custom-wrapper]"
				);
				const customDropdownElements = this.querySelectorAll(
					"[js-no-variant-dropdown] ul li"
				);

				customDropdownValue.forEach((item) => {
					item.addEventListener("click", (event) => {
						const dropDown = item.closest("[js-no-variant-dropdown]");
						customDropdown.forEach((item) => {
							if (dropDown != item) item.classList.remove("active");
						});
						dropDown.classList.toggle("active");
					});
				});

				customDropdownElements.forEach((item) => {
					item.addEventListener("click", (event) => {
						const dropDown = item.closest("[js-no-variant-dropdown]");
						const valueElement = dropDown.querySelector("[js-custom-value]");
						dropDown.classList.remove("active");
						const value = item.getAttribute("data-value");
						valueElement.innerText = value;

						const siblingsElements = dropDown.querySelectorAll("ul li");
						siblingsElements.forEach((element) => {
							element.classList.remove("hidden");
						});
						item.classList.add("hidden");

						const productUrl = item.getAttribute("data-product-url");
						const parent = item.closest("[js-product-item]");

						this.renderProduct(productUrl, parent);
					});
				});

				document.addEventListener("click", (event) => {
					if (event.target.closest(".variant-select-dropdown") == null) {
						customDropdown.forEach((item) => {
							item.classList.remove("active");
						});
					}
				});
			}
		}
	);
}
